import React from 'react'

interface IProps {
  resetKey: string
  children: React.ReactNode
}

interface IState {
  hasError: boolean
}

export class NotificationToastErrorBoundary extends React.Component<IProps, IState> {
  state: IState = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    console.warn('[Notifications] toast rendering failed:', error)
  }

  componentDidUpdate(prevProps: IProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) return null

    return this.props.children
  }
}
